'use strict';

export var methods = new Set(['get', 'put', 'post', 'delete', 'options', 'head', 'patch']);
